import i18n from 'i18n';
import { ValueFormatterParams } from '@ag-grid-enterprise/all-modules';

export function warrantStateValue(value:string): string {
  if (value === 'ACTIVE') {
    return i18n.t('common.grid.warrantState.active');
  }

  if (value === 'TRASH') {
    return i18n.t('common.grid.warrantState.trash');
  }

  if (value === 'PENDING') {
    return i18n.t('common.grid.warrantState.pending');
  }

  if (value === 'EXPIRED') {
    return i18n.t('common.grid.warrantState.expired');
  }

  if (value === 'STOPPED') {
    return i18n.t('common.grid.warrantState.stopped');
  }

  if (value === 'PAUSED') {
    return i18n.t('common.grid.warrantState.paused');
  }

  if (value === 'MIXED') {
    return i18n.t('common.grid.warrantState.mixed');
  }

  return i18n.t('common.grid.empty');
}

export default function warrantStateValueFormatter({ value }: Partial<ValueFormatterParams>): string {
  return warrantStateValue(value);
}
